module.exports = __webpack_public_path__ + "static/media/problem.aa9d4c53.svg";